import { RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { NodeId, Campaigns } from '../entities/article';
import { ArticleEnvironment } from '../environment';

export class CampaignRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ArticleEnvironment).campaignsUrl, session, { 'x-device-key': true });
  }

  getCampaigns = (nodeId: NodeId): SafePromise<Campaigns> => {
    const url = this.URL(`/ajax-cache/bz-campaign/${nodeId}/next`);
    return this.get(url, { allowsAnonymousAuth: true, cache: 'no-cache', credentials: 'same-origin' });
  };
}
